import React from 'react';
import './about.css';
import UIDesign from '../../assets/ui-design.png';
import software_eng from '../../assets/software-icon.png';
import ai_img from '../../assets/ai.png';
import AppDesign from '../../assets/app-design.png';

const About = () => {
  return (
    <section id="about">
        <span className="aboutTitle">What I do</span>
        <span className="aboutPara">Long term: my vision is to help people through cost-effective technology solutions, especially AI. Short term: Learn, learn, learn.</span>
        <div className="aboutBars">
            <div className="aboutBar">
                <img src={software_eng} alt="Software Engineering" className="aboutBarImg" />
                <div className="aboutBarText">
                    <h2>Software Engineering</h2>
                    <p>I've dived into coding challenges and projects, crafting programs that solve puzzles and automate tasks, showcasing my problem-solving skills and dedication to learning.</p>
                </div>
            </div>
            <div className="aboutBar">
                <img src={ai_img} alt="AI Research" className="aboutBarImg" />
                <div className="aboutBarText">
                    <h2>AI Research</h2>
                    <p>I've been exploring AI concepts through online courses and personal projects, fascinated by the potential of machines to understand human language and make smart decisions.</p>
                </div>
            </div>
            <div className="aboutBar">
                <img src={AppDesign} alt="AppDesign" className="aboutBarImg" />
                <div className="aboutBarText">
                    <h2>App Design</h2>
                    <p> Building practical mobile apps has been my focus, creating tools that make life easier and learning new technologies to bring creative ideas to users' fingertips.</p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default About
